module.exports = __webpack_public_path__ + "media/svg-new/file-bug-319c1e4b.svg";